import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RequestAudit from "@/pages/RequestAudit";

export const Route = createFileRoute("/zh-cn/request-your-audit")({
  head: () => buildRouteHead("/zh-cn/request-your-audit"),
  component: RequestAudit,
});

